import { motion, AnimatePresence } from 'framer-motion';

import { useOrderbookStore } from '@/store/orderbook';

export const EventCurrencySwap = () => {
  const { isUsdc, setIsUsdc } = useOrderbookStore();

  return (
    <div className="flex items-center gap-1">
      <div className="relative size-6 sm:size-8">
        <AnimatePresence>
          {isUsdc && (
            <motion.div
              className="absolute size-6 sm:size-8"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.8 }}
              transition={{ duration: 0.2 }}
            >
              <img
                src="/icons/usdc.svg"
                alt="usdc"
                className="size-full rounded-full"
              />
            </motion.div>
          )}
        </AnimatePresence>

        <AnimatePresence>
          {!isUsdc && (
            <motion.div
              className="absolute size-6 sm:size-8"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.8 }}
              transition={{ duration: 0.2 }}
            >
              <img
                src="/icons/sol.svg"
                alt="sol"
                className="size-full rounded-full"
              />
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      <motion.button
        onClick={() => setIsUsdc(!isUsdc)}
        className="flex size-6 items-center justify-center sm:size-8"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        animate={{ rotate: isUsdc ? 180 : 0 }}
        transition={{
          duration: 0.3,
          type: 'spring',
          stiffness: 260,
          damping: 20,
        }}
      >
        <img src="/icons/swap.svg" alt="swap" />
      </motion.button>
    </div>
  );
};
